import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { PromiseResult } from '../models/PromiseResult';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { feedbackModel, feedbackUpdateModel } from '../models/feedback';
import { PaginationModel } from '../models/util.models';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {
    constructor(private readonly httpClient: HttpClient) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    sendCovidFeedback(
        data: feedbackModel,
        source: string
    ): Observable<PromiseResult> {
        return this.httpClient
            .post<PromiseResult>(
                RestApi.Urls.TestimonialApi + 'Submit/' + source,
                data
            )
            .pipe(catchError(this.handleError));
    }

    getCovidFeedbacks(pagination: PaginationModel): Observable<PromiseResult> {
        return this.httpClient
            .post<PromiseResult>(
                RestApi.Urls.TestimonialApi + 'GetAll/covid',
                pagination
            )
            .pipe(catchError(this.handleError));
    }

    updateCovidFeedback(data: feedbackUpdateModel): Observable<PromiseResult> {
        return this.httpClient
            .put<PromiseResult>(
                RestApi.Urls.TestimonialApi + 'Update/covid',
                data
            )
            .pipe(catchError(this.handleError));
    }

    getFeaturedTestimonials(): Observable<PromiseResult> {
        return this.httpClient
            .get<PromiseResult>(
                RestApi.Urls.TestimonialApi + 'GetAll/covid/Featured'
            )
            .pipe(catchError(this.handleError));
    }
}
